// src/pages/Edajima/Home.js
import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CustomDropdown from "../../components/CustomDropdown";
import "../../styles/HomeGlobals.css";
import "../../styles/HomeStyle.css";
import "../../styles/HomeStyleGuide.css";
import "../../styles/Dropdown.css";
import { saveUserProfile, resetUserId } from "../../utils/firebase"; // ★ 追加

// ★ 地域コードをハードコード（必要に応じて値を変更してください）
const REGION_CODE = "016";

export default function Home() {
  const { t, i18n } = useTranslation(); // ★ i18n も取得
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    age: '',
    gender: '',
    usage: ''
  });

  // 年代のオプション
  const ageOptions = [
    { value: 'under10', label: t('under10') },
    { value: '10s', label: t('10s') },
    { value: '20s', label: t('20s') },
    { value: '30s', label: t('30s') },
    { value: '40s', label: t('40s') },
    { value: '50s', label: t('50s') },
    { value: '60s', label: t('60s') },
    { value: '70s', label: t('70s') },
    { value: '80s', label: t('80s') }
  ];

  // 性別のオプション
  const genderOptions = [
    { value: 'male', label: t('male') },
    { value: 'female', label: t('female') },
    { value: 'other', label: t('other') }
  ];

  // 利用形態のオプション
  const usageOptions = [
    { value: 'personal', label: t('personal') },
    { value: 'business', label: t('business') },
    { value: 'education', label: t('education') }
  ];

  const handleAgeSelect = (option) => {
    setFormData(prev => ({ ...prev, age: option.value }));
  };

  const handleGenderSelect = (option) => {
    setFormData(prev => ({ ...prev, gender: option.value }));
  };

  const handleUsageSelect = (option) => {
    setFormData(prev => ({ ...prev, usage: option.value }));
  };

  // ★ アンケート送信時に profileData をまとめて保存
  const handleSubmit = async () => {
    if (!formData.age || !formData.gender || !formData.usage) {
      alert(t('please fill out all fields'));
      return;
    }
  
    try {
      // ★ ここで「新しい人用」の userId を発行
      const newUserId = resetUserId();
      console.log('New userId created:', newUserId);
  
      // ★ このあと saveUserProfile 内部の getUserId() は newUserId を返す
      await saveUserProfile({
        language: i18n.language,   // 使用言語
        age: formData.age,         // アンケート: 年代
        gender: formData.gender,   // アンケート: 性別
        usage: formData.usage,     // アンケート: 利用目的
        regionCode: REGION_CODE    // 地域コード（ハードコード）
      });
  
      navigate('/tatsuminomori/renttutorial', { state: formData });
    } catch (e) {
      console.error('Failed to save profile', e);
      alert(t('failedToSaveProfile', 'データの保存に失敗しました'));
    }
  };
  
  return (
    <div className="select-language">
      <div className="overlap-group-wrapper">
        <div className="overlap-group">
          <div className="rectangle"></div>
          <div className="app-logo-area">
            <img className="limot" src="/images/logo_limot.png" alt="Limot logo" />
          </div>
          <p className="app-description-ja">
            {t('Please answer the following questions')}<br />
            {t('before using the service.')}
          </p>
          
          <fieldset className="age-fieldset">
            <legend className="text-wrapper-2">{t('1.Age')}</legend>
            <CustomDropdown
              options={ageOptions}
              placeholder={t("Please select")}
              onSelect={handleAgeSelect}
              ariaLabel={t("Select your age.")}
              className="age-dropdown"
            />
          </fieldset>
          
          <fieldset className="gender-fieldset">
            <legend className="text-wrapper-3">{t('2.Gender')}</legend>
            <CustomDropdown
              options={genderOptions}
              placeholder={t('Select your gender')}
              onSelect={handleGenderSelect}
              ariaLabel={t("Select your gender")}
              className="gender-dropdown"
            />
          </fieldset>
          
          <fieldset className="usage-fieldset">
            <legend className="text-wrapper-4">{t('3.Purpose')}</legend>
            <CustomDropdown
              options={usageOptions}
              placeholder={t('Select your purpose')}
              onSelect={handleUsageSelect}
              ariaLabel={t("Select your purpose")}
              className="usage-dropdown"
            />
          </fieldset>
          
          <button type="button" className="mode-button" onClick={handleSubmit}>
            <span className="text-wrapper-6">{t('Next')}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
